import React from "react";

import { ItemShareDialog } from "#app/components/issue-actions/item-share-dialog";
import { createDialogEmitter } from "#app/lib/dialog-emitter";

type ItemShareDialogActions = {
  openDialog: (issueId: string) => void;
  closeDialog: () => void;
};

// Callers inside bottom-sheet portals (kanban card menus on mobile, the
// issue-view three-dot menu) cannot read React context, so open and close go
// through the emitter.
const itemShareDialog = createDialogEmitter<string>("item_share");

export function useItemShareDialogActions(): ItemShareDialogActions {
  return React.useMemo<ItemShareDialogActions>(
    () => ({ openDialog: itemShareDialog.open, closeDialog: itemShareDialog.close }),
    [],
  );
}

export function ItemShareDialogMount() {
  const { open, payload: issueId } = itemShareDialog.useDialogState();
  return (
    <ItemShareDialog
      issueId={open ? issueId : null}
      onOpenChange={(next) => {
        if (!next) itemShareDialog.close();
      }}
    />
  );
}
